import { arrayRemove, arrayUnion, doc, getFirestore, updateDoc } from 'firebase/firestore';
import Styles from './styles.module.css';
import React from 'react'

type RecruitEditBackProps = {
  blockPopup: string;
  setBlockPopup: React.Dispatch<React.SetStateAction<string>>;
  setBlock: React.Dispatch<React.SetStateAction<string[]>>;
  schoolId: string;
};

const RecruitEditBack: React.FC<RecruitEditBackProps> = ({ blockPopup, setBlockPopup, setBlock, schoolId }) => {

  const db = getFirestore();
  
  const handleBlockChange = async (id: string, checked: boolean) => {
    // ① ローカル state 更新
    setBlock((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );

    // ② Firestore 更新
    const schoolRef = doc(db, "schools", schoolId);

    try {
      await updateDoc(schoolRef, {
        blockList: arrayUnion(id),
      });
    } catch (error) {
      console.error("blockList 更新エラー", error);
    }
  };

  return (
    <>
    <div className={Styles.modal}>
      <div>
        <div className={Styles.modal_black} onClick={() => setBlockPopup("")}></div>
        <div className={Styles.modal_contents}>
          <h4>ブロック確認</h4>
          <p>
            ブロックをすると、学生様のアプリに求人票が表示されません。本当にブロックしますか？<br />
          </p>
          <div>
            <button style={{backgroundColor : 'white', color : 'var(--mw-error)'}} onClick={() => { setBlockPopup(""); handleBlockChange(blockPopup, true)}}>ブロックする</button>
            <button style={{backgroundColor : 'var(--mw-error)', color : 'white'}} onClick={() => setBlockPopup("")}>戻る</button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default RecruitEditBack;


